var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"petitTexte"},[_vm._v("Vous pouvez consulter le prix de l'offre dans la "),_c('a',{staticClass:"realText petitTexte",attrs:{"href":_vm.appConfig.config.$api_url + '/api/v1/attachment/free/pdf/MER_VISIO_TARIFS',"target":"_blank"}},[_vm._v(" grille tarifaire Visio.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }